(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toggle = document.querySelector('[data-filter-toggle]');
    const panel = document.querySelector('[data-filter-panel]');
    toggle?.addEventListener('click', () => {
      panel?.classList.toggle('is-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.pf-contact-form__native').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';

      const fields = form.querySelectorAll('input, textarea');
      fields.forEach((field) => {
        field.addEventListener('invalid', () => field.setAttribute('aria-invalid', 'true'));
        field.addEventListener('input', () => field.removeAttribute('aria-invalid'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-pf-header]');
    const drawer = document.querySelector('[data-pf-header-drawer]');
    const openButtons = document.querySelectorAll('[data-pf-header-menu]');
    const closeButtons = document.querySelectorAll('[data-pf-header-close]');

    const setScrollState = () => {
      if (!header) return;

      if (header.classList.contains('pf-header--about-page')) {
        header.dataset.scrolled = 'false';
        return;
      }

      header.dataset.scrolled = window.scrollY > 12 ? 'true' : 'false';
    };

    const openDrawer = () => {
      if (!drawer) return;
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
    };

    openButtons.forEach((button) => button.addEventListener('click', openDrawer));
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    drawer?.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });

    const updateCartCount = (count) => {
      const countNodes = document.querySelectorAll('.pf-header__cart-count');
      countNodes.forEach((countNode) => {
        if (count > 0) {
          countNode.textContent = count;
          countNode.removeAttribute('hidden');
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.setAttribute('hidden', 'true');
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    document.addEventListener('cart:update', (event) => {
      let count = 0;
      if (event.detail?.resource?.items !== undefined) {
        count = event.detail.resource.items.length;
      } else if (event.detail?.resource?.item_count !== undefined) {
        count = event.detail.resource.items ? event.detail.resource.items.length : Number(event.detail.resource.item_count);
      } else {
        const comingFromProductForm = event.detail?.data?.source === 'product-form-component';
        const currentCountNode = document.querySelector('.pf-header__cart-count');
        const currentCount = currentCountNode ? Number(currentCountNode.textContent) : 0;
        count = comingFromProductForm ? currentCount + Number(event.detail?.data?.itemCount ?? 0) : Number(event.detail?.data?.itemCount ?? 0);
      }
      updateCartCount(count);
    });

    setScrollState();
    window.addEventListener('scroll', setScrollState, { passive: true });
    window.addEventListener('resize', setScrollState, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pf-hero]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const track = root.querySelector('[data-track]');
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      const autoplay = Number(root.dataset.autoplay || 0);
      let index = 0;
      let timer;

      const activate = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      prev?.addEventListener('click', () => activate(index - 1));
      next?.addEventListener('click', () => activate(index + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => activate(Number(dot.dataset.dot))));

      if (autoplay > 0 && slides.length > 1) {
        timer = window.setInterval(() => activate(index + 1), autoplay);
        root.addEventListener('mouseenter', () => window.clearInterval(timer));
        root.addEventListener('mouseleave', () => { timer = window.setInterval(() => activate(index + 1), autoplay); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koya-pickle-combo-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const runtimeLocale = document.querySelector('[data-koya-bundle]')?.dataset.locale || document.documentElement.lang || navigator.language || 'en-IN';
    const runtimeCurrency =
      document.querySelector('[data-koya-bundle]')?.dataset.currency ||
      document.querySelector('meta[property="og:price:currency"]')?.content ||
      'INR';
    const moneyFormatter = new Intl.NumberFormat(runtimeLocale, {
      style: 'currency',
      currency: runtimeCurrency,
      maximumFractionDigits: 2,
    });

    const formatMoney = (cents) => {
      try {
        return moneyFormatter.format((Number(cents) || 0) / 100);
      } catch (error) {
        return (document.querySelector('[data-koya-bundle]')?.dataset.currencySymbol || '₹') + ((Number(cents) || 0) / 100).toFixed(2);
      }
    };

    const showToast = (section, message) => {
      const toast = section.querySelector('[data-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._hideTimer);
      toast._hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2600);
    };

    const syncHeaderCartCount = (itemCount) => {
      const count = Number(itemCount) || 0;
      const cartLink =
        document.querySelector('.wew-header__right a[href*="/cart"]') ||
        document.querySelector('.rauhath-header__actions a[href*="/cart"]') ||
        document.querySelector('.header-actions__cart-icon');

      if (cartLink) {
        let countNode =
          cartLink.querySelector('.wew-header__cart-count') ||
          cartLink.querySelector('.rauhath-header__cart-count') ||
          cartLink.querySelector('.cart-bubble__text-count');
        if (!countNode) {
          countNode = document.createElement('span');
          countNode.className = 'wew-header__cart-count';
          cartLink.appendChild(countNode);
        }

        if (count > 0) {
          if (countNode.classList?.contains('cart-bubble__text-count')) {
            countNode.textContent = count < 100 ? String(count) : '';
            const cartBubble = countNode.closest('.cart-bubble');
            if (cartBubble) {
              cartBubble.classList.remove('visually-hidden');
            }
          } else {
            countNode.textContent = String(count);
            countNode.hidden = false;
            countNode.removeAttribute('aria-hidden');
          }
        } else {
          if (countNode.classList?.contains('cart-bubble__text-count')) {
            countNode.textContent = '';
            const cartBubble = countNode.closest('.cart-bubble');
            if (cartBubble) {
              cartBubble.classList.add('visually-hidden');
            }
          } else {
            countNode.textContent = '0';
            countNode.hidden = true;
            countNode.setAttribute('aria-hidden', 'true');
          }
        }
      }

      try {
        sessionStorage.setItem(
          'cart-count',
          JSON.stringify({
            value: String(count),
            timestamp: Date.now(),
          })
        );
      } catch (error) {
        // Session storage may be unavailable in some browser modes.
      }
    };

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));

    const initBundle = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const vegRequired = Number(section.dataset.vegRequired || 3);
      const nonVegRequired = Number(section.dataset.nonvegRequired || 1);
      const discountPercent = Number(section.dataset.discountPercent || 0);
      const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
      const cartUrl = section.dataset.cartUrl || '/cart';
      const cards = Array.from(section.querySelectorAll('[data-bundle-card]'));
      const vegCards = cards.filter((card) => card.dataset.group === 'veg');
      const nonVegCards = cards.filter((card) => card.dataset.group === 'nonveg');
      const vegCountNode = section.querySelector('[data-veg-count]');
      const nonVegCountNode = section.querySelector('[data-nonveg-count]');
      const totalCountNode = section.querySelector('[data-selected-total-count]');
      const listNode = section.querySelector('[data-bundle-list]');
      const originalTotalNode = section.querySelector('[data-original-total]');
      const comboTotalNode = section.querySelector('[data-combo-total]');
      const savingsNode = section.querySelector('[data-savings-amount]');
      const savingsRow = section.querySelector('[data-savings-row]');
      const addButtons = Array.from(section.querySelectorAll('[data-add-combo]'));
      const addButtonLabels = Array.from(section.querySelectorAll('[data-add-combo-label]'));
      const mobileCount = section.querySelector('[data-mobile-count]');
      const mobileTotal = section.querySelector('[data-mobile-total]');
      const fillButtons = Array.from(section.querySelectorAll('[data-fill-default]'));

      const selected = {
        veg: [],
        nonveg: [],
      };

      const selectedCards = () => [...selected.veg, ...selected.nonveg];

      const cardPrice = (card) => Number(card.dataset.price || 0);

      const isCardDisabled = () => false;
      const isCardSoldOut = (card) => card?.dataset.disabled === 'true';

      const getCardVariantButtons = (card) => Array.from(card.querySelectorAll('[data-variant-option]'));

      const applySelectionState = () => {
        updateSummary();
      };

      const selectVariant = (card, variantButton, event) => {
        if (!card || !variantButton) return;

        event?.preventDefault();
        event?.stopPropagation();

        syncVariantSelection(card, variantButton);
        selectCard(card);
        applySelectionState();
      };

      const activateCard = (card, event) => {
        if (!card) return;

        event?.preventDefault();
        event?.stopPropagation();

        toggleCard(card);
        applySelectionState();
      };

      const syncVariantSelection = (card, variantButton) => {
        if (!card || !variantButton) return;

        const variantId = variantButton.dataset.variantId;
        const variantPrice = Number(variantButton.dataset.variantPrice || 0);
        const variantLabel = variantButton.dataset.variantLabel || variantButton.textContent.trim();

        card.dataset.variantId = variantId;
        card.dataset.price = String(variantPrice);
        card.dataset.variantLabel = variantLabel;

        const priceNode = card.querySelector('[data-card-price]');
        if (priceNode) {
          priceNode.textContent = formatMoney(variantPrice);
        }

        getCardVariantButtons(card).forEach((button) => {
          button.classList.toggle('is-active', button === variantButton);
        });
      };

      const selectCard = (card) => {
        if (!card) return false;

        const group = card.dataset.group;
        const alreadySelected = selectedCards().includes(card);
        if (alreadySelected) return true;

        if (group === 'veg') {
          if (selected.veg.length >= vegRequired) {
            showToast(section, `Select only ${vegRequired} core items.`);
            return false;
          }
          selected.veg.push(card);
        } else {
          if (selected.nonveg.length >= nonVegRequired) {
            showToast(section, `Select only ${nonVegRequired} featured item.`);
            return false;
          }
          selected.nonveg.push(card);
        }

        return true;
      };

      const toggleCard = (card) => {
        if (!card) return false;

        const alreadySelected = selectedCards().includes(card);
        if (alreadySelected) {
          selected.veg = selected.veg.filter((item) => item !== card);
          selected.nonveg = selected.nonveg.filter((item) => item !== card);
          return true;
        }

        return selectCard(card);
      };

      const updateButtons = () => {
        cards.forEach((card) => {
          const isSelected = selectedCards().includes(card);
          card.classList.toggle('is-selected', isSelected);
          card.classList.toggle('is-disabled', isCardSoldOut(card));
          card.classList.toggle('is-soldout', isCardSoldOut(card));
          card.dataset.selected = isSelected ? 'true' : 'false';
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const updateSummary = () => {
        const vegLength = selected.veg.length;
        const nonVegLength = selected.nonveg.length;
        const totalLength = vegLength + nonVegLength;
        const originalTotal = selectedCards().reduce((sum, card) => sum + cardPrice(card), 0);
        const savings = totalLength === vegRequired + nonVegRequired ? Math.round(originalTotal * (discountPercent / 100)) : 0;
        const comboTotal = originalTotal - savings;
        const complete = vegLength === vegRequired && nonVegLength === nonVegRequired;

        if (vegCountNode) vegCountNode.textContent = `${vegLength}/${vegRequired} selected`;
        if (nonVegCountNode) nonVegCountNode.textContent = `${nonVegLength}/${nonVegRequired} selected`;
        if (totalCountNode) totalCountNode.textContent = String(totalLength);
        if (originalTotalNode) originalTotalNode.textContent = formatMoney(originalTotal);
        if (comboTotalNode) comboTotalNode.textContent = formatMoney(comboTotal);
        if (mobileCount) mobileCount.textContent = `${totalLength}/${vegRequired + nonVegRequired} selected`;
        if (mobileTotal) mobileTotal.textContent = formatMoney(comboTotal);

        if (savingsRow) {
          savingsRow.hidden = !complete || savings <= 0;
        }
        if (savingsNode) {
          savingsNode.textContent = formatMoney(savings);
        }

        const canAdd = complete;
        addButtons.forEach((button) => {
          button.disabled = !canAdd;
        });
        const buttonLabel = canAdd
          ? 'Add Set to Cart'
          : `Select ${Math.max(0, vegRequired - vegLength)} core items and ${Math.max(0, nonVegRequired - nonVegLength)} featured accent item`;
        addButtonLabels.forEach((label) => {
          label.textContent = buttonLabel;
        });

        if (listNode) {
          if (!totalLength) {
            listNode.innerHTML = '<p class="koya-bundle__empty">Choose 3 core home pieces and 1 featured accent item.</p>';
          } else {
            listNode.innerHTML = selectedCards()
              .map((card) => {
                const variantMarkup = card.dataset.variantLabel
                  ? ' <small>' + escapeHtml(card.dataset.variantLabel) + '</small>'
                  : '';

                return (
                  '<p class="koya-bundle__summary-item"><span>' +
                  escapeHtml(card.dataset.title) +
                  variantMarkup +
                  '</span><strong>' +
                  formatMoney(card.dataset.price) +
                  '</strong></p>'
                );
              })
              .join('');
          }
        }

        updateButtons();
      };

      section.addEventListener('click', (event) => {
        const variantButton = event.target.closest('[data-variant-option]');
        if (variantButton && section.contains(variantButton)) {
          const card = variantButton.closest('[data-bundle-card]');
          if (!card) return;
          selectVariant(card, variantButton, event);
          return;
        }

        const card = event.target.closest('[data-bundle-card]');
        if (!card || !section.contains(card)) return;
        activateCard(card, event);
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const variantButton = event.target.closest('[data-variant-option]');
        if (variantButton && section.contains(variantButton)) {
          return;
        }

        const card = event.target.closest('[data-bundle-card]');
        if (!card || !section.contains(card)) return;
        event.preventDefault();
        activateCard(card, event);
      });

      fillButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          selected.veg = vegCards.filter((card) => !isCardDisabled(card)).slice(0, vegRequired);
          selected.nonveg = nonVegCards.filter((card) => !isCardDisabled(card)).slice(0, nonVegRequired);
          applySelectionState();
        });
      });

      const addCombo = async () => {
        const complete = selected.veg.length === vegRequired && selected.nonveg.length === nonVegRequired;
        if (!complete) return;

        const items = selectedCards().map((card) => ({ id: Number(card.dataset.variantId), quantity: 1 }));
        const buttonState = addButtons.map((button) => button.disabled);
        const buttonLabelState = addButtonLabels.map((label) => label.textContent);
        addButtons.forEach((button) => {
          button.disabled = true;
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
        });
        addButtonLabels.forEach((label) => {
          label.textContent = 'Adding...';
        });

        try {
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error('Cart add failed');
          const cart = await response.json();
          showToast(section, 'Set added to cart successfully.');
          syncHeaderCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              data: {
                source: 'koya-home-bundle',
                itemCount: cart.item_count,
              },
            },
          }));
        } catch (error) {
          showToast(section, 'Added to cart failed. Please try again.');
        } finally {
          addButtons.forEach((button, index) => {
            button.disabled = buttonState[index] ?? false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          });
          addButtonLabels.forEach((label, index) => {
            label.textContent = buttonLabelState[index] ?? label.textContent;
          });
          updateSummary();
        }
      };

      addButtons.forEach((button) =>
        button.addEventListener('click', (event) => {
          event.preventDefault();
          addCombo();
        })
      );

      applySelectionState();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-koya-bundle]').forEach(initBundle);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-bestsellers"] && !Shopify.designMode) return;
  try {
    
  class MyPerfumeRail {
    constructor(section) {
      if (!section || section.dataset.ready === 'true') return;
      this.section = section;
      this.root = section.querySelector('[data-myperfume-carousel]');
      this.track = section.querySelector('[data-myperfume-track]');
      this.prev = section.querySelector('[data-myperfume-prev]');
      this.next = section.querySelector('[data-myperfume-next]');
      if (!this.track) return;
      if (!this.root) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
      this.root.style.scrollBehavior = 'smooth';

      let startX = 0;
      let startY = 0;
      let startScroll = 0;
      let dragging = false;
      let pointerMoved = false;
      let gestureLocked = false;
      let gestureAxis = null;

      this.root.addEventListener('pointerdown', (event) => {
        dragging = true;
        pointerMoved = false;
        gestureLocked = false;
        gestureAxis = null;
        startX = event.clientX;
        startY = event.clientY;
        startScroll = this.root.scrollLeft;
      });

      this.root.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!gestureLocked) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;

          gestureLocked = true;
          gestureAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';

          if (gestureAxis === 'x') {
            pointerMoved = true;
            this.root.setPointerCapture(event.pointerId);
            this.root.style.scrollSnapType = 'none';
          } else {
            dragging = false;
            this.root.style.scrollSnapType = 'x mandatory';
            return;
          }
        }

        if (gestureAxis !== 'x') return;

        event.preventDefault();
        this.root.scrollLeft = startScroll - deltaX;
      });

      const stopDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        this.root.style.scrollSnapType = 'x mandatory';
        if (event && this.root.hasPointerCapture(event.pointerId)) {
          this.root.releasePointerCapture(event.pointerId);
        }
        if (pointerMoved && gestureAxis === 'x') {
          this.snapToNearest();
        }
      };

      this.root.addEventListener('pointerup', stopDrag);
      this.root.addEventListener('pointercancel', stopDrag);
      this.root.addEventListener('pointerleave', stopDrag);

      section.dataset.ready = 'true';
    }

    scroll(direction) {
      const card = this.track.firstElementChild;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const amount = (card?.clientWidth || this.root.clientWidth * 0.8) + gap;
      this.root.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    snapToNearest() {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const step = card.clientWidth + gap;
      if (!step) return;
      const nextIndex = Math.round(this.root.scrollLeft / step);
      this.root.scrollTo({ left: nextIndex * step, behavior: 'smooth' });
    }
  }

  const initMyPerfumeRails = (scope = document) => {
    scope.querySelectorAll('[data-myperfume-rail-section]').forEach((node) => new MyPerfumeRail(node));
  };

  const initMyPerfumeBuyNowCards = (scope = document) => {
    scope.querySelectorAll('[data-buy-now-card-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const variantInput = form.querySelector('[data-variant-id-input]');
      const buttons = Array.from(form.closest('.myperfume-bestsellers__card')?.querySelectorAll('[data-size-button]') || []);
      if (!variantInput || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          variantInput.value = button.dataset.variantId || variantInput.value;
          buttons.forEach((other) => {
            const isActive = other === button;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMyPerfumeRails());
  document.addEventListener('DOMContentLoaded', () => initMyPerfumeBuyNowCards());
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeRails(event.target));
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeBuyNowCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-dark-collection"] && !Shopify.designMode) return;
  try {
    
  const initMyPerfumeDarkBuyNowCards = (scope = document) => {
    scope.querySelectorAll('[data-buy-now-card-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';

      const variantInput = form.querySelector('[data-variant-id-input]');
      const buttons = Array.from(form.closest('.myperfume-dark-card')?.querySelectorAll('[data-size-button]') || []);
      if (!variantInput || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          variantInput.value = button.dataset.variantId || variantInput.value;
          buttons.forEach((other) => {
            const isActive = other === button;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMyPerfumeDarkBuyNowCards());
  document.addEventListener('shopify:section:load', (event) => initMyPerfumeDarkBuyNowCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myperfume-footer-promo"] && !Shopify.designMode) return;
  try {
    
  const initStoreFooterFeatureCarousel = (scope = document) => {
    scope.querySelectorAll('.store-footer').forEach((section) => {
      if (section.dataset.featureCarouselReady === 'true') return;
      section.dataset.featureCarouselReady = 'true';

      const track = section.querySelector('.store-footer__features');
      if (!track || track.children.length < 2) return;

      let timer = null;

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        timer = window.setInterval(() => {
          const slides = Array.from(track.children);
          const first = slides[0];
          if (!first) return;

          const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
          const step = first.getBoundingClientRect().width + gap;
          const maxScroll = track.scrollWidth - track.clientWidth - 1;

          if (track.scrollLeft >= maxScroll) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: step, behavior: 'smooth' });
          }
        }, 2800);
      };

      start();
      window.addEventListener('resize', start, { passive: true });
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });
      track.addEventListener('touchcancel', start, { passive: true });
    });
  };

  const initStoreFooterAccordions = (scope = document) => {
    scope.querySelectorAll('.store-footer__menu').forEach((details) => {
      if (details.dataset.ready === 'true') return;
      details.dataset.ready = 'true';

      const syncState = () => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          details.open = false;
        } else {
          details.open = true;
        }
      };

      syncState();
      window.addEventListener('resize', syncState, { passive: true });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initStoreFooterFeatureCarousel());
  document.addEventListener('DOMContentLoaded', () => initStoreFooterAccordions());
  document.addEventListener('shopify:section:load', (event) => initStoreFooterFeatureCarousel(event.target));
  document.addEventListener('shopify:section:load', (event) => initStoreFooterAccordions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pf-carousel]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const tabs = root.querySelectorAll('.pf-carousel__tab-btn');
      const panes = root.querySelectorAll('.pf-carousel__pane');

      // Progress bar logic
      const updateProgressBar = (pane) => {
        if (!pane) return;
        const track = pane.querySelector('[data-track]');
        const thumb = pane.querySelector('[data-thumb]');
        if (!track || !thumb) return;

        const update = () => {
          const scrollLeft = track.scrollLeft;
          const maxScroll = track.scrollWidth - track.clientWidth;
          const percentage = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
          thumb.style.left = `${percentage * 0.7}%`; // thumb width is 30%
        };

        track.addEventListener('scroll', update);
        // Initial run
        update();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = tab.dataset.tabIndex;

          tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          panes.forEach((p) => p.classList.toggle('is-active', p.dataset.paneIndex === index));
          
          const activePane = root.querySelector(`.pf-carousel__pane.is-active`);
          updateProgressBar(activePane);
        });
      });

      panes.forEach((pane) => {
        updateProgressBar(pane);

        const track = pane.querySelector('[data-track]');
        const prev = root.querySelector('[data-prev]');
        const next = root.querySelector('[data-next]');
        if (track) {
          const step = () => track.querySelector('.pop-card')?.getBoundingClientRect().width || 320;
          prev?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
          next?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-pf-product]');
    if (!root) return;

    const gallery = root.querySelector('[data-pf-gallery]');
    const slidesRail = root.querySelector('[data-pf-slides]');
    const slides = [...root.querySelectorAll('[data-pf-slide]')];
    const thumbs = [...root.querySelectorAll('[data-pf-thumb]')];
    const dots = [...root.querySelectorAll('[data-pf-dot]')];
    const swatches = [...root.querySelectorAll('[data-pf-swatch]')];
    const variantIdInput = root.querySelector('[data-pf-variant-id]');
    const variantSelect = root.querySelector('[data-pf-variant-select]');
    const accordions = [...root.querySelectorAll('.pf-product-template__accordion')];
    const faqItems = [...root.querySelectorAll('.pf-product-template__faq-item')];
    const qtyField = root.querySelector('[data-pf-qty-field]');
    const qtyInput = root.querySelector('[data-pf-qty-input]');
    const minus = root.querySelector('[data-pf-qty-minus]');
    const plus = root.querySelector('[data-pf-qty-plus]');
    const relatedTrack = root.querySelector('[data-pf-related-track]');
    const relatedPrev = root.querySelector('[data-pf-related-prev]');
    const relatedNext = root.querySelector('[data-pf-related-next]');
    const reallifeTrack = root.querySelector('[data-pf-reallife-track]');
    const reallifePrev = root.querySelector('[data-pf-reallife-prev]');
    const reallifeNext = root.querySelector('[data-pf-reallife-next]');
    const lookbookTrack = root.querySelector('[data-pf-lookbook-track]');
    const lookbookPrev = root.querySelector('[data-pf-lookbook-prev]');
    const lookbookNext = root.querySelector('[data-pf-lookbook-next]');
    const wishlist = root.querySelector('[data-pf-wishlist]');
    const navPrev = root.querySelector('[data-pf-nav-prev]');
    const navNext = root.querySelector('[data-pf-nav-next]');
    const shareBtn = root.querySelector('[data-pf-share]');

    if (relatedTrack && relatedPrev && relatedNext) {
      const getRelatedStep = () => {
        const firstCard = relatedTrack.querySelector('.pf-product-template__related-card');
        if (!firstCard) return relatedTrack.clientWidth;
        const gap = parseFloat(window.getComputedStyle(relatedTrack).columnGap || 0);
        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateRelatedControls = () => {
        const maxScroll = relatedTrack.scrollWidth - relatedTrack.clientWidth;
        const canScroll = maxScroll > 1;
        relatedPrev.disabled = !canScroll || relatedTrack.scrollLeft <= 1;
        relatedNext.disabled = !canScroll || relatedTrack.scrollLeft >= maxScroll - 1;
      };

      relatedPrev.addEventListener('click', () => {
        relatedTrack.scrollBy({ left: -getRelatedStep(), behavior: 'smooth' });
      });

      relatedNext.addEventListener('click', () => {
        relatedTrack.scrollBy({ left: getRelatedStep(), behavior: 'smooth' });
      });

      let relatedRaf = 0;
      relatedTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(relatedRaf);
        relatedRaf = requestAnimationFrame(updateRelatedControls);
      });

      window.addEventListener('resize', updateRelatedControls);
      updateRelatedControls();
    }

    if (reallifeTrack && reallifePrev && reallifeNext) {
      const getReallifeStep = () => {
        const firstCard = reallifeTrack.querySelector('.pf-product-template__reallife-card');
        if (!firstCard) return reallifeTrack.clientWidth;
        const gap = parseFloat(window.getComputedStyle(reallifeTrack).columnGap || 0);
        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateReallifeControls = () => {
        const maxScroll = reallifeTrack.scrollWidth - reallifeTrack.clientWidth;
        const canScroll = maxScroll > 1;
        reallifePrev.disabled = !canScroll || reallifeTrack.scrollLeft <= 1;
        reallifeNext.disabled = !canScroll || reallifeTrack.scrollLeft >= maxScroll - 1;
      };

      reallifePrev.addEventListener('click', () => {
        reallifeTrack.scrollBy({ left: -getReallifeStep(), behavior: 'smooth' });
      });

      reallifeNext.addEventListener('click', () => {
        reallifeTrack.scrollBy({ left: getReallifeStep(), behavior: 'smooth' });
      });

      let reallifeRaf = 0;
      reallifeTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(reallifeRaf);
        reallifeRaf = requestAnimationFrame(updateReallifeControls);
      });

      window.addEventListener('resize', updateReallifeControls);
      updateReallifeControls();
    }

    if (lookbookTrack && lookbookPrev && lookbookNext) {
      const getLookbookStep = () => {
        const firstCard = lookbookTrack.querySelector('.pf-product-template__lookbook-card');
        if (!firstCard) return lookbookTrack.clientWidth;
        const gap = parseFloat(window.getComputedStyle(lookbookTrack).columnGap || 0);
        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateLookbookControls = () => {
        const maxScroll = lookbookTrack.scrollWidth - lookbookTrack.clientWidth;
        const canScroll = maxScroll > 1;
        lookbookPrev.disabled = !canScroll || lookbookTrack.scrollLeft <= 1;
        lookbookNext.disabled = !canScroll || lookbookTrack.scrollLeft >= maxScroll - 1;
      };

      lookbookPrev.addEventListener('click', () => {
        lookbookTrack.scrollBy({ left: -getLookbookStep(), behavior: 'smooth' });
      });

      lookbookNext.addEventListener('click', () => {
        lookbookTrack.scrollBy({ left: getLookbookStep(), behavior: 'smooth' });
      });

      let lookbookRaf = 0;
      lookbookTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(lookbookRaf);
        lookbookRaf = requestAnimationFrame(updateLookbookControls);
      });

      window.addEventListener('resize', updateLookbookControls);
      updateLookbookControls();
    }

    accordions.forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        if (accordion.open) {
          accordions.forEach((other) => {
            if (other !== accordion) other.open = false;
          });
        }
      });
    });

    faqItems.forEach((faqItem) => {
      faqItem.addEventListener('toggle', () => {
        if (faqItem.open) {
          faqItems.forEach((other) => {
            if (other !== faqItem) other.open = false;
          });
        }
      });
    });

    const setActive = (index) => {
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
    };

    const syncVariant = (variantId) => {
      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }

      if (variantSelect && variantId) {
        variantSelect.value = variantId;
      }
    };

    const goToSlide = (index) => {
      const slide = slides[index];
      if (!slide || !slidesRail) return;
      const targetLeft = slide.offsetLeft - (slidesRail.clientWidth - slide.clientWidth) / 2;
      slidesRail.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth'
      });
      setActive(index);
    };

    const goToMediaId = (mediaId) => {
      if (!mediaId) return;
      const index = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (index >= 0) {
        goToSlide(index);
      }
    };

    const getNearestIndex = () => {
      const rail = slidesRail || gallery;
      const rect = rail.getBoundingClientRect();
      const railCenter = rect.left + rect.width / 2;
      let bestIndex = 0;
      let bestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - railCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    };

    if (slidesRail && slides.length) {
      let raf = 0;
      slidesRail.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => setActive(getNearestIndex()));
      });

      thumbs.forEach((thumb, index) => {
        const onThumbActivate = (event) => {
          event?.preventDefault?.();
          goToSlide(index);
        };

        thumb.addEventListener('click', onThumbActivate);
        thumb.addEventListener('pointerup', onThumbActivate);
        thumb.addEventListener('touchend', onThumbActivate, { passive: false });
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => goToSlide(index));
      });

      navPrev?.addEventListener('click', () => {
        const current = slides.findIndex((s) => s.classList.contains('is-active'));
        goToSlide(Math.max(0, current - 1));
      });

      navNext?.addEventListener('click', () => {
        const current = slides.findIndex((s) => s.classList.contains('is-active'));
        goToSlide(Math.min(slides.length - 1, current + 1));
      });

      setActive(0);
    }

    const stickyBar = root.querySelector('[data-pf-sticky-bar]');
    const stickyAddBtn = root.querySelector('[data-pf-sticky-add]');
    const stickyPrice = root.querySelector('[data-pf-sticky-price]');
    const stickyTitleCount = root.querySelector('[data-pf-sticky-title-count]');

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', async () => {
        const variantId = variantIdInput?.value || stickyAddBtn.dataset.variantId;
        if (!variantId || stickyAddBtn.disabled) return;

        const quantity = Number(qtyField?.value || qtyInput?.value || 1);
        const originalText = stickyAddBtn.textContent;
        stickyAddBtn.disabled = true;
        stickyAddBtn.textContent = 'Adding...';

        try {
          const cartItemsComponents = document.querySelectorAll('cart-items-component');
          const sectionIds = [];
          cartItemsComponents.forEach((item) => {
            if (item.dataset.sectionId && !sectionIds.includes(item.dataset.sectionId)) {
              sectionIds.push(item.dataset.sectionId);
            }
          });

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', quantity);
          if (sectionIds.length > 0) {
            formData.append('sections', sectionIds.join(','));
            formData.append('sections_url', window.location.pathname);
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          if (!response.ok) throw new Error('Add to cart failed');
          const addData = await response.json();

          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cartData,
              sourceId: 'pf-product-template',
              data: {
                itemCount: cartData.item_count,
                sections: addData.sections
              }
            }
          }));

          const cartDrawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer], cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
          }

          stickyAddBtn.textContent = 'Added!';
          setTimeout(() => {
            stickyAddBtn.textContent = originalText;
            stickyAddBtn.disabled = false;
          }, 1500);
        } catch (err) {
          stickyAddBtn.textContent = 'Try again';
          setTimeout(() => {
            stickyAddBtn.textContent = originalText;
            stickyAddBtn.disabled = false;
          }, 1500);
        }
      });
    }

    const variantDataEl = root.querySelector('[id^="VariantData-"]');
    const variantData = variantDataEl ? JSON.parse(variantDataEl.textContent) : {};

    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = parseInt(cents, 10);
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = format.match(placeholderRegex);
      if (!match) return cents;

      const placeholder = match[1];
      switch (placeholder) {
        case 'amount':
          value = (cents / 100).toFixed(2);
          break;
        case 'amount_no_decimals':
          value = Math.round(cents / 100).toString();
          break;
        case 'amount_with_comma_separator':
          value = (cents / 100).toFixed(2).replace('.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = Math.round(cents / 100).toString().replace('.', ',');
          break;
        default:
          value = (cents / 100).toFixed(2);
      }

      if (placeholder.includes('comma_separator')) {
        const parts = value.split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        value = parts.join(',');
      } else {
        const parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        value = parts.join('.');
      }

      return format.replace(placeholderRegex, value);
    }

    const updateStickyBar = () => {
      if (!stickyPrice) return;

      const variantId = variantIdInput?.value || stickyAddBtn?.dataset.variantId;
      const quantity = Math.max(1, Number(qtyField?.value || qtyInput?.value || 1));

      if (stickyTitleCount) {
        stickyTitleCount.textContent = quantity > 1 ? `x${quantity}` : '';
        stickyTitleCount.style.display = quantity > 1 ? 'inline-block' : 'none';
      }

      if (variantId && variantData[variantId]) {
        const basePrice = variantData[variantId].price;
        const totalPrice = basePrice * quantity;
        const moneyFormat = stickyPrice.dataset.moneyFormat || '₹{{amount}}';
        stickyPrice.textContent = formatMoney(totalPrice, moneyFormat);

        if (stickyAddBtn) {
          stickyAddBtn.dataset.variantId = variantId;
          const available = variantData[variantId].available;
          stickyAddBtn.disabled = !available;
          const addBtnText = stickyAddBtn.querySelector('[data-pf-sticky-add-text]') || stickyAddBtn;
          if (addBtnText) {
            addBtnText.textContent = available ? 'Add to cart' : 'Sold out';
          }
        }
      }
    };

    swatches.forEach((swatch) => {
      const activateSwatch = (event) => {
        event?.preventDefault?.();
        const variantId = swatch.dataset.variantId;
        const mediaId = swatch.dataset.mediaId;

        swatches.forEach((item) => {
          const active = item === swatch;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        syncVariant(variantId);
        updateStickyBar();
        goToMediaId(mediaId);
      };

      swatch.addEventListener('click', activateSwatch);
      swatch.addEventListener('pointerup', activateSwatch);
      swatch.addEventListener('touchend', activateSwatch, { passive: false });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        syncVariant(variantSelect.value);
        updateStickyBar();
      });
    }



    // Write Review Button Click Trigger for Judge.me Form
    const writeReviewBtn = root.querySelector('[data-pf-write-review]');
    if (writeReviewBtn) {
      writeReviewBtn.addEventListener('click', (e) => {
        e.preventDefault();
        
        // 1. Try Judge.me official JS API if available
        if (window.jdgm && typeof window.jdgm.openWriteReviewModal === 'function') {
          window.jdgm.openWriteReviewModal();
          return;
        }
        // 2. Locate and toggle Judge.me Form element directly
        const jmForm = document.querySelector('.jdgm-write-rev-form')
          || document.querySelector('.jdgm-rev-form')
          || document.querySelector('form.jdgm-form')
          || document.querySelector('.jm-review-form');
        if (jmForm) {
          const isHidden = window.getComputedStyle(jmForm).display === 'none' || jmForm.hidden;
          if (isHidden) {
            jmForm.style.display = 'block';
            jmForm.removeAttribute('hidden');
            jmForm.classList.add('jdgm-is-active');
          } else {
            jmForm.style.display = 'none';
            jmForm.classList.remove('jdgm-is-active');
          }
          jmForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        // 3. Fallback: Trigger mouse click on Judge.me's native button anywhere on page
        const jmWriteBtn = document.querySelector('[data-testid="write-review-button"]')
          || document.querySelector('.jm-action-buttons__button')
          || document.querySelector('.jdgm-write-rev-link')
          || document.querySelector('.jdgm-rev-mgr__write-rev-btn');
        if (jmWriteBtn) {
          jmWriteBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          try { jmWriteBtn.click(); } catch(err) {}
        }
      });
    }

    // Dynamic Review Badge Sync with Judge.me Widget
    const reviewsBadge = root.querySelector('[data-pf-reviews-badge]') || root.querySelector('.pf-product-template__reviews-badge');
    const updateDynamicRating = () => {
      if (!reviewsBadge) return;

      // 1. Try finding rating text from Judge.me summary elements
      const avgEl = document.querySelector('.jdgm-rev-wid__summary-average')
        || document.querySelector('.jdgm-prev-badge__stars')
        || document.querySelector('.jdgm-histogram__average');
      
      let ratingText = avgEl ? avgEl.textContent.trim() : null;

      // 2. Try data-average-rating attribute on Judge.me elements
      if (!ratingText || isNaN(parseFloat(ratingText))) {
        const widget = document.querySelector('#judgeme_product_reviews[data-average-rating]')
          || document.querySelector('.jdgm-rev-wid[data-average-rating]')
          || document.querySelector('.jdgm-prev-badge[data-average-rating]');
        if (widget) {
          ratingText = widget.getAttribute('data-average-rating');
        }
      }

      // 3. Fallback to Judge.me global JS object
      if (!ratingText && window.jdgm && window.jdgm.product && window.jdgm.product.rating) {
        ratingText = window.jdgm.product.rating;
      }

      // 4. Update badge dynamically if valid rating is found
      if (ratingText) {
        const numRating = parseFloat(ratingText);
        if (!isNaN(numRating) && numRating > 0) {
          reviewsBadge.textContent = `${numRating.toFixed(1)} ★`;
        }
      }
    };

    updateDynamicRating();

    // Observe changes inside the Judge.me widget container
    const reviewsWidgetContainer = root.querySelector('[data-pf-reviews-widget]') || document.body;
    if (reviewsWidgetContainer) {
      const observer = new MutationObserver(() => {
        updateDynamicRating();
      });
      observer.observe(reviewsWidgetContainer, { childList: true, subtree: true, characterData: true });
    }

    shareBtn?.addEventListener('click', async () => {
      const shareData = { title: document.title, url: window.location.href };
      if (navigator.share) {
        try {
          await navigator.share(shareData);
        } catch (err) {}
      } else if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(shareData.url);
        } catch (err) {}
      }
    });

    const syncQty = (value) => {
      const next = Math.max(1, Number(value || 1));
      if (qtyField) qtyField.value = next;
      if (qtyInput) qtyInput.value = next;
      updateStickyBar();
    };

    minus?.addEventListener('click', () => {
      syncQty((Number(qtyField?.value || qtyInput?.value || 1)) - 1);
    });

    plus?.addEventListener('click', () => {
      syncQty((Number(qtyField?.value || qtyInput?.value || 1)) + 1);
    });

    qtyInput?.addEventListener('input', () => syncQty(qtyInput.value));
    qtyField?.addEventListener('input', () => syncQty(qtyField.value));

    // Initialize sticky bar pricing on load
    updateStickyBar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rauhath-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateCartCount = (itemCount) => {
      const cartLink = document.querySelector('.rauhath-header__actions a[href*="/cart"]');
      if (!cartLink) return;

      let countNode = cartLink.querySelector('.rauhath-header__cart-count');
      if (!countNode) {
        countNode = document.createElement('span');
        countNode.className = 'rauhath-header__cart-count';
        cartLink.appendChild(countNode);
      }

      if (itemCount > 0) {
        countNode.textContent = String(itemCount);
        countNode.hidden = false;
        countNode.removeAttribute('aria-hidden');
      } else {
        countNode.textContent = '0';
        countNode.hidden = true;
        countNode.setAttribute('aria-hidden', 'true');
      }
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-custom-gift-combo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, locale, currency) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return (currency === 'INR' ? '₹' : '$') + ((Number(cents) || 0) / 100).toFixed(2);
      }
    };

    const showToast = (section, message) => {
      let toast = section.querySelector('[data-gift-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'wew-gift-combo__toast';
        toast.dataset.giftToast = 'true';
        section.appendChild(toast);
      }

      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._hideTimer);
      toast._hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2400);
    };

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));

    const syncHeaderCartCount = (itemCount) => {
      const count = Number(itemCount) || 0;
      const cartTrigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('.wew-header__right a[href*="/cart"]') ||
        document.querySelector('.wew-mobile-tabs a[href*="/cart"]');

      if (!cartTrigger) return;

      const countNode =
        cartTrigger.querySelector('.wew-header__cart-count') ||
        cartTrigger.querySelector('.wew-mobile-tabs__badge');

      if (countNode) countNode.textContent = String(count);
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      const cartLink = document.querySelector('.wew-mobile-tabs a[href*="/cart"]');
      if (cartLink) {
        window.location.href = cartLink.href;
      }
    };

    const setupLoopCarousel = (carousel) => {
      if (!(carousel instanceof HTMLElement) || carousel.dataset.loopReady === 'true') return;
      const originals = Array.from(carousel.children).filter(
        (child) => child instanceof HTMLElement && child.hasAttribute('data-gift-card')
      );

      if (originals.length < 3) return;

      carousel.dataset.loopReady = 'true';

      const cloneCards = (cards) =>
        cards.map((card) => {
          const clone = card.cloneNode(true);
          if (clone instanceof HTMLElement) {
            clone.removeAttribute('data-gift-card');
            clone.dataset.giftCardClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('role', 'presentation');
          }
          return clone;
        });

      const prepend = document.createDocumentFragment();
      const append = document.createDocumentFragment();

      cloneCards(originals).reverse().forEach((clone) => prepend.appendChild(clone));
      cloneCards(originals).forEach((clone) => append.appendChild(clone));

      carousel.prepend(prepend);
      carousel.append(append);

      const measureLoopWidth = () => {
        const cardWidth = originals[0].getBoundingClientRect().width;
        const styles = getComputedStyle(carousel);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return (cardWidth + gap) * originals.length;
      };

      const resetToMiddle = () => {
        const width = measureLoopWidth();
        carousel.scrollLeft = width;
      };

      requestAnimationFrame(resetToMiddle);

      let rafId = 0;
      const normalizeScroll = () => {
        window.cancelAnimationFrame(rafId);
        rafId = window.requestAnimationFrame(() => {
          const width = measureLoopWidth();
          const total = carousel.scrollWidth;
          const leftEdge = width * 0.45;
          const rightEdge = total - carousel.clientWidth - width * 0.45;

          if (carousel.scrollLeft <= leftEdge) {
            carousel.scrollLeft += width;
          } else if (carousel.scrollLeft >= rightEdge) {
            carousel.scrollLeft -= width;
          }
        });
      };

      carousel.addEventListener('scroll', normalizeScroll, { passive: true });
      window.addEventListener('resize', resetToMiddle, { passive: true });
    };

    const initGiftCombo = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-gift-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-gift-panel]'));
      const cards = Array.from(section.querySelectorAll('.wew-gift-combo__carousel > [data-gift-card]'));
      const selectedIds = [];

      const locale = section.dataset.locale || document.documentElement.lang || navigator.language || 'en-IN';
      const currency = section.dataset.currency || 'INR';
      const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
      const discountThreshold = Number(section.dataset.discountThreshold || 99900);
      const discountPercent = Number(section.dataset.discountPercent || 5);

      const summaryList = section.querySelector('[data-gift-summary-list]');
      const subtotalNode = section.querySelector('[data-gift-subtotal]');
      const savingsNode = section.querySelector('[data-gift-savings]');
      const totalNode = section.querySelector('[data-gift-total]');
      const discountRow = section.querySelector('[data-gift-discount-row]');
      const progressFill = section.querySelector('[data-gift-progress]');
      const progressCopy = section.querySelector('[data-gift-progress-copy]');
      const countNode = section.querySelector('[data-gift-count]');
      const addButton = section.querySelector('[data-gift-add]');
      const addLabel = section.querySelector('[data-gift-add-label]');
      const resetButton = section.querySelector('[data-gift-reset]');

      const cardsById = new Map(cards.map((card) => [card.dataset.giftId, card]));
      const carousel = section.querySelector('[data-gift-carousel]');
      if (carousel) {
        setupLoopCarousel(carousel);
      }

      const selectedCards = () => selectedIds.map((id) => cardsById.get(id)).filter(Boolean);

      const updateCardState = () => {
        cards.forEach((card) => {
          const isSelected = selectedIds.includes(card.dataset.giftId);
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const renderSummary = () => {
        const items = selectedCards();
        const subtotal = items.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        const thresholdReached = subtotal >= discountThreshold;
        const savings = thresholdReached ? Math.round((subtotal * discountPercent) / 100) : 0;
        const total = subtotal - savings;
        const progress = discountThreshold > 0 ? Math.min((subtotal / discountThreshold) * 100, 100) : 0;

        if (countNode) countNode.textContent = `${items.length} selected`;
        if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, locale, currency);
        if (savingsNode) savingsNode.textContent = formatMoney(savings, locale, currency);
        if (totalNode) totalNode.textContent = formatMoney(total, locale, currency);
        if (progressFill) progressFill.style.width = `${progress}%`;
        if (discountRow) discountRow.hidden = !thresholdReached || savings <= 0;

        if (progressCopy) {
          if (!items.length) {
            progressCopy.textContent = 'Start selecting products';
          } else if (thresholdReached) {
            progressCopy.textContent = `${discountPercent}% savings unlocked`;
          } else {
            const remaining = Math.max(discountThreshold - subtotal, 0);
            progressCopy.textContent = `${formatMoney(remaining, locale, currency)} left to unlock ${discountPercent}% off`;
          }
        }

        if (summaryList) {
          if (!items.length) {
            summaryList.innerHTML =
              '<p class="wew-gift-combo__empty">Choose products from one or more occasion tabs. The combo stays in sync as you add or remove items.</p>';
          } else {
              summaryList.innerHTML = items
              .map((card) => {
                const title = card.dataset.title || 'Product';
                const price = card.dataset.price || 0;
                return `
                  <p class="wew-gift-combo__summary-item" data-selected-item="${card.dataset.giftId}">
                    <span>
                      ${escapeHtml(title)}
                      <small>${escapeHtml(card.dataset.collection || '')}</small>
                    </span>
                    <strong>
                      ${formatMoney(price, locale, currency)}
                      <button type="button" data-remove-gift-id="${card.dataset.giftId}" aria-label="Remove ${escapeHtml(title)}">Remove</button>
                    </strong>
                  </p>
                `;
              })
              .join('');
          }
        }

        if (addButton) {
          addButton.disabled = items.length === 0;
        }
        if (addLabel) {
          if (!items.length) {
            addLabel.textContent = 'Pick items to continue';
          } else {
          addLabel.textContent = thresholdReached ? 'Add combo with savings' : 'Add room combo';
          }
        }

        updateCardState();
      };

      const activatePanel = (targetId) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.target === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      const addCard = (card) => {
        if (card.dataset.available === 'false') {
          showToast(section, 'This product is sold out.');
          return;
        }

        if (selectedIds.includes(card.dataset.giftId)) return;

        selectedIds.push(card.dataset.giftId);
        renderSummary();
      };

      const removeCard = (giftId) => {
        const index = selectedIds.indexOf(giftId);
        if (index === -1) return;
        selectedIds.splice(index, 1);
        renderSummary();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activatePanel(tab.dataset.target));
      });

      section.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-gift-id]');
        if (removeButton) {
          event.preventDefault();
          removeCard(removeButton.dataset.removeGiftId);
          return;
        }

        const toggleButton = event.target.closest('[data-gift-card-toggle]');
        if (toggleButton) {
          const card = toggleButton.closest('[data-gift-card]');
          if (!card) return;
          event.preventDefault();
          if (selectedIds.includes(card.dataset.giftId)) {
            removeCard(card.dataset.giftId);
          } else {
            addCard(card);
          }
          return;
        }

        const card = event.target.closest('[data-gift-card]');
        if (!card) return;

        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-gift-card]');
        if (!card) return;
        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      addButton?.addEventListener('click', async () => {
        const items = selectedCards().map((card) => ({
          id: Number(card.dataset.variantId),
          quantity: 1,
        }));

        addButton.disabled = true;
        addButton.dataset.loading = 'true';

        try {
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const cart = await response.json();
          if (!response.ok || cart?.status) {
            throw new Error(cart?.description || cart?.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'wew-gift-combo',
                  itemCount: cart.item_count,
                },
              },
            })
          );

          syncHeaderCartCount(cart.item_count);
          showToast(section, 'Your room combo was added to cart.');
          openCartDrawer();
        } catch (error) {
          console.error(error);
          showToast(section, 'We could not add the combo. Please try again.');
        } finally {
          addButton.disabled = selectedIds.length === 0;
          addButton.dataset.loading = 'false';
          renderSummary();
        }
      });

      resetButton?.addEventListener('click', () => {
        selectedIds.length = 0;
        renderSummary();
      });

      const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
      if (initialTab?.dataset.target) {
        activatePanel(initialTab.dataset.target);
      }

      renderSummary();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-wew-gift-combo]').forEach(initGiftCombo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-premium-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('.wew-header--hero-overlay');
    let lastScrollY = window.scrollY;

    const applyHeroHeaderState = () => {
      if (!header) return;

      if (header.classList.contains('wew-header--about-page')) {
        header.dataset.scrollDirection = 'none';
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
        return;
      }

      const currentScrollY = window.scrollY;
      const isAtTop = currentScrollY <= 12;
      const isScrollingUp = currentScrollY < lastScrollY;
      const isScrollingDown = currentScrollY > lastScrollY;

      header.dataset.scrollDirection = isAtTop ? 'none' : isScrollingUp ? 'up' : isScrollingDown ? 'down' : header.dataset.scrollDirection || 'none';

      if (isAtTop) {
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
      } else if (isScrollingUp) {
        header.dataset.scrolled = 'true';
        header.dataset.stickyState = 'active';
      } else if (isScrollingDown) {
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
      }

      lastScrollY = currentScrollY;
    };

    const updateCartCount = (itemCount) => {
      const cartButtons = document.querySelectorAll('.wew-header__cart-button, .wew-mobile-tabs__item[href*="/cart"], .wew-mobile-tabs__item[aria-label="Cart"]');
      
      cartButtons.forEach((cartBtn) => {
        let countNode = cartBtn.querySelector('.wew-header__cart-count, .wew-mobile-tabs__badge');
        
        if (!countNode) {
          countNode = document.createElement('span');
          if (cartBtn.classList.contains('wew-mobile-tabs__item')) {
            countNode.className = 'wew-mobile-tabs__badge';
            const iconWrapper = cartBtn.querySelector('.wew-mobile-tabs__icon');
            if (iconWrapper) {
              iconWrapper.appendChild(countNode);
            } else {
              cartBtn.appendChild(countNode);
            }
          } else {
            countNode.className = 'wew-header__cart-count';
            cartBtn.appendChild(countNode);
          }
        }

        if (itemCount > 0) {
          countNode.textContent = String(itemCount);
          countNode.style.display = '';
          countNode.hidden = false;
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.style.display = 'none';
          countNode.hidden = true;
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const readSessionCount = () => {
      try {
        const raw = sessionStorage.getItem('cart-count');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const value = Number(parsed?.value);
        return Number.isFinite(value) ? value : null;
      } catch (error) {
        return null;
      }
    };

    const syncFromServer = async () => {
      try {
        const response = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;
        const cart = await response.json();
        updateCartCount(Number(cart?.item_count) || 0);
      } catch (error) {
        // Ignore network failures; the session/event-based sync will still work.
      }
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    window.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    const initialCount = readSessionCount();
    if (initialCount !== null) {
      updateCartCount(initialCount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFromServer, { once: true });
    } else {
      syncFromServer();
    }

    const openMobileMenu = () => {
      const drawer = document.querySelector('header-drawer.header-drawer');
      const details = drawer?.querySelector('details.menu-drawer-container');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }

      if (details) {
        details.open = true;
        details.setAttribute('open', '');
        details.classList.add('menu-open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      window.location.href = document.querySelector('.wew-mobile-tabs a[href*="/cart"]')?.href || '/cart';
    };

    document.querySelectorAll('[data-open-mobile-menu]').forEach((button) => {
      button.addEventListener('click', openMobileMenu);
    });

    document.querySelectorAll('[data-open-cart-drawer]').forEach((button) => {
      button.addEventListener('click', openCartDrawer);
    });

    document.querySelectorAll('[data-cart-drawer-recommendations]').forEach((drawer) => {
      const track = drawer.querySelector('.cart-drawer__recommendations-track');
      const prev = drawer.querySelector('[data-cart-drawer-recommendations-prev]');
      const next = drawer.querySelector('[data-cart-drawer-recommendations-next]');
      const slides = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-slide]'));
      const dots = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-dot]'));

      if (!track || slides.length === 0) return;

      const getStep = () => {
        const slide = slides[0];
        const slideWidth = slide.getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
        return slideWidth + gap;
      };

      const setActiveDot = (index) => {
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const setArrowState = () => {
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      };

      const getActiveIndex = () => {
        const viewportCenter = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - viewportCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const updateActiveState = () => {
        setActiveDot(getActiveIndex());
        setArrowState();
      };

      prev?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.cartDrawerRecommendationDot || 0);
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateActiveState);
      }, { passive: true });

      window.addEventListener('resize', updateActiveState, { passive: true });
      updateActiveState();
    });

    if (header) {
      applyHeroHeaderState();
      window.addEventListener('scroll', applyHeroHeaderState, { passive: true });
      window.addEventListener('resize', applyHeroHeaderState, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-premium-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-wew-hero]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const track = root.querySelector('[data-track]');
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const prevBtn = root.querySelector('[data-action="prev"]');
    const nextBtn = root.querySelector('[data-action="next"]');
    const autoplay = Number(root.dataset.autoplay) || 0;
    let index = 0;
    let timer = null;
    let pointerId = null;
    let dragStartX = 0;
    let dragDeltaX = 0;
    let isDragging = false;

    if (slides.length <= 1 || !track) return;

    const counterEl = root.querySelector('[data-counter-current]');
    const autoplayMs = autoplay > 0 ? autoplay : 6000;

    // Set CSS var for dot fill animation duration
    root.style.setProperty('--wew-autoplay', autoplayMs + 'ms');

    const activate = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        // Force animation restart by toggling class
        if (active) {
          dot.classList.remove('is-active');
          void dot.offsetWidth; // reflow
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
        dot.setAttribute('aria-selected', String(active));
      });

      // Update counter
      if (counterEl) {
        const num = String(index + 1).padStart(2, '0');
        counterEl.textContent = num;
      }
    };

    prevBtn?.addEventListener('click', () => activate(index - 1));
    nextBtn?.addEventListener('click', () => activate(index + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => activate(Number(dot.dataset.dot)));
    });

    root.addEventListener('mouseenter', () => {
      if (timer) { clearInterval(timer); timer = null; }
    });
    root.addEventListener('mouseleave', () => {
      if (autoplay > 0 && slides.length > 1) {
        timer = setInterval(() => activate(index + 1), autoplay);
      }
    });

    root.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerId = e.pointerId;
      dragStartX = e.clientX;
      dragDeltaX = 0;
      isDragging = true;
      if (timer) { clearInterval(timer); timer = null; }
      track.style.transition = 'none';
    });

    root.addEventListener('pointermove', (e) => {
      if (!isDragging || e.pointerId !== pointerId) return;
      dragDeltaX = e.clientX - dragStartX;
      const offset = -index * 100 + (dragDeltaX / root.offsetWidth) * 100;
      track.style.transform = `translateX(${offset}%)`;
    });

    root.addEventListener('pointerup', () => {
      if (!isDragging) return;
      isDragging = false;
      pointerId = null;
      track.style.transition = '';
      const threshold = 25;
      if (dragDeltaX < -threshold) {
        activate(index + 1);
      } else if (dragDeltaX > threshold) {
        activate(index - 1);
      } else {
        activate(index);
      }
      dragDeltaX = 0;
      if (autoplay > 0 && slides.length > 1) {
        timer = setInterval(() => activate(index + 1), autoplay);
      }
    });

    root.addEventListener('pointercancel', () => {
      if (!isDragging) return;
      isDragging = false;
      pointerId = null;
      track.style.transition = '';
      activate(index);
      dragDeltaX = 0;
      if (autoplay > 0 && slides.length > 1) {
        timer = setInterval(() => activate(index + 1), autoplay);
      }
    });

    window.addEventListener('resize', () => activate(index));

    activate(index);
    if (autoplay > 0 && slides.length > 1) {
      timer = setInterval(() => activate(index + 1), autoplay);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChibiSpotlight = (scope = document) => {
      scope.querySelectorAll('[data-wew-spotlight]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-spotlight-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-spotlight-panel]'));
        const seeAll = section.querySelector('[data-spotlight-see-all]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        if (!tabs.length || !panels.length) return;

        const activate = (targetId) => {
          tabs.forEach((tab) => {
            const isActive = tab.dataset.spotlightTarget === targetId;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;

            if (isActive && seeAll && panel.dataset.spotlightUrl) {
              seeAll.href = panel.dataset.spotlightUrl;
            }
          });
        };

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => activate(tab.dataset.spotlightTarget));
        });

        section.querySelectorAll('[data-wew-spotlight-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();

            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;
            button.dataset.loading = 'true';

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1,
                }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) {
                throw new Error(cart?.description || cart?.message || 'Add to cart failed');
              }

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'wew-spotlight',
                      itemCount: cart.item_count,
                    },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
              button.dataset.loading = 'false';
            }
          });
        });

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab?.dataset.spotlightTarget) {
          activate(activeTab.dataset.spotlightTarget);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initChibiSpotlight());
    document.addEventListener('shopify:section:load', (event) => initChibiSpotlight(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wew-story-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChibiStories = (scope = document) => {
      scope.querySelectorAll('[data-wew-story-collections]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-story-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-story-panel]'));
        const seeAll = section.querySelector('[data-story-see-all]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        if (!tabs.length || !panels.length) return;

        const activate = (targetId) => {
          tabs.forEach((tab) => {
            const isActive = tab.dataset.storyTarget === targetId;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.hidden = !isActive;
            panel.classList.toggle('is-active', isActive);

            if (isActive && seeAll && panel.dataset.storyUrl) {
              seeAll.href = panel.dataset.storyUrl;
            }
          });
        };

        tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.storyTarget)));

        section.querySelectorAll('[data-wew-story-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();

            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) throw new Error(cart?.description || cart?.message || 'Add to cart failed');

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'wew-story-collections',
                      itemCount: cart.item_count,
                    },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
            }
          });
        });

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab?.dataset.storyTarget) {
          activate(activeTab.dataset.storyTarget);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initChibiStories());
    document.addEventListener('shopify:section:load', (event) => initChibiStories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-drawer"]) return;
  try {
    
(function() {
  const drawer   = document.getElementById('wishlist-drawer');
  const backdrop = document.getElementById('wishlist-drawer-backdrop');
  const closeBtn = document.getElementById('wishlist-drawer-close');
  const grid     = document.getElementById('wishlist-drawer-grid');
  const empty    = document.getElementById('wishlist-drawer-empty');

  if (!drawer) return;

  function openDrawer() {
    drawer.setAttribute('open', '');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderGrid();
  }

  function closeDrawer() {
    drawer.removeAttribute('open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Close on backdrop / close button / Escape
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  drawer.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  function renderGrid() {
    const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
    if (list.length === 0) {
      grid.innerHTML = '';
      grid.style.display  = 'none';
      empty.style.display = '';
      return;
    }
    grid.style.display  = '';
    empty.style.display = 'none';
    grid.innerHTML = list.map(item => {
      const t  = (item.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      const img = item.image || '';
      return `
        <div class="wl-drawer-card">
          <a class="wl-drawer-card__img-link" href="/products/${item.handle}">
            ${img ? `<img class="wl-drawer-card__img" src="${img}" alt="${t}" loading="lazy">` : ''}
          </a>
          <div class="wl-drawer-card__info">
            <a class="wl-drawer-card__title" href="/products/${item.handle}">${t}</a>
            <span class="wl-drawer-card__price">${item.price || ''}</span>
          </div>
          <button
            class="wl-drawer-card__remove"
            type="button"
            aria-label="Remove from wishlist"
            aria-pressed="true"
            data-wishlist-button
            data-product-handle="${item.handle}"
            data-product-id="${item.id || ''}"
            data-product-title="${t}"
            data-product-image="${img}"
            data-product-price="${item.price || ''}"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M12 20.5s-7.6-4.6-10-9.2C.5 8 1.7 4.6 5 3.5c2.2-.7 4.3.2 5.6 2 .4.5 1 1.4 1.4 2.1.4-.7 1-1.6 1.4-2.1 1.3-1.8 3.4-2.7 5.6-2 3.3 1.1 4.5 4.5 3 7.8-2.4 4.6-10 9.2-10 9.2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>`;
    }).join('');
  }

  // Re-render when wishlist changes
  document.addEventListener('wishlist:update', renderGrid);

  // Listen for the open trigger (header button dispatches this)
  document.addEventListener('wishlist-drawer:open', openDrawer);

  // Expose globally so the header button can call it
  window.openWishlistDrawer = openDrawer;
})();

  } catch(e) { console.error(e); }
})();
})();
